// extracted by mini-css-extract-plugin
export default {"appUISection":"AppInterfaces_appUISection__NR++9","AppUI":"AppInterfaces_AppUI__UiTlq","slider":"AppInterfaces_slider__J5+do"};